const sortNumeral = (arr = [], isReversed, prop) => {
  const plusOne = !isReversed ? 1 : -1
  const minusOne = !isReversed ? -1 : 1
  return [
    ...arr.sort((a, b) => {
      const ratio = a?.[prop] < b?.[prop]
      return ratio ? minusOne : plusOne
    })
  ]
}

// const sortNumeral = (arr, isReversed, propA, propB, multipleProps) => {
//   const plusOne = !isReversed ? 1 : -1
//   const minusOne = !isReversed ? -1 : 1
//   return [
//     ...arr.sort((a, b) => {
//       // TODO: make playingTime & substitutionTime abstracted properties
//       const aRatio = multipleProps ? a[propA] / a[propB] : a[propA]
//       const bRatio = multipleProps ? b[propA] / b[propB] : b[propA]
//       if (aRatio === bRatio && multipleProps) return a[propA] < b[propB] ? plusOne : minusOne
//       return aRatio < bRatio ? minusOne : plusOne
//     })
//   ]
// }

export default sortNumeral
